import { ROSELoader } from "./rose";

// TODO: More efficient uncompressed loading
// TODO: Test RGB, RBA, Alpha, Luminance, LuminanceAlpha
// TODO: Test Cubemap

export class DDSHeader {
    magic: any;
    size: any;
    flags: any;
    height: any;
    width: any;
    pitch: any;
    depth: any;
    mipmaps: any;
    pixelFormat: DDSPixelFormat;
    caps1: any;
    caps2: any;
    caps3: any;
    caps4: any;

    constructor() {
        this.pixelFormat = new DDSPixelFormat();
    }
}

export class DDSPixelFormat {
    size: any;
    flags: any;
    fourCC: any;
    bitCount: any;
    maskR: any;
    maskG: any;
    maskB: any;
    maskA: any;

    constructor() {}
}

export class DDSMipmap {
    width: any;
    height: any;
    data: any;

    constructor(width: any, height: any) {
        this.width = width;
        this.height = height;
        this.data = null;
    }
}

/**
 * Make a Uint32 FOURCC from a String
 */
function makeFourCC(string: any) {
    return (
        string.charCodeAt(0) +
        (string.charCodeAt(1) << 8) +
        (string.charCodeAt(2) << 16) +
        (string.charCodeAt(3) << 24)
    );
}

export const DDS_MAGIC = 0x20534444;

export const DDS_FLAGS = {
    CAPS: 0x1,
    HEIGHT: 0x2,
    WIDTH: 0x4,
    PITCH: 0x8,
    PIXEL_FORMAT: 0x1000,
    MIPMAP_COUNT: 0x20000,
    LINEAR_SIZE: 0x80000,
    DEPTH: 0x800000,
};

export const DDS_CAPS = {
    COMPLEX: 0x8,
    MIPMAP: 0x400000,
    TEXTURE: 0x1000,
};

export const DDS_CAPS2 = {
    CUBEMAP: 0x200,
    CUBEMAP_POSITIVEX: 0x400,
    CUBEMAP_NEGATIVEX: 0x800,
    CUBEMAP_POSITIVEY: 0x1000,
    CUBEMAP_NEGATIVEY: 0x2000,
    CUBEMAP_POSITIVEZ: 0x4000,
    CUBEMAP_NEGATIVEZ: 0x8000,
    VOLUME: 0x200000,
};

export const DDS_PIXEL_FORMAT_FOURCC = {
    DXT1: makeFourCC("DXT1"),
    DXT3: makeFourCC("DXT3"),
    DXT5: makeFourCC("DXT5"),
};

export const DDS_PIXEL_FORMAT_FLAGS = {
    ALPHA_PIXELS: 0x1,
    ALPHA: 0x2,
    FOURCC: 0x4,
    RGB: 0x40,
    YUV: 0x200,
    LUMINANCE: 0x20000,
};

export class OldDDS {
    static Header = DDSHeader;
    static PixelFormat = DDSPixelFormat;
    static Mipmap = DDSMipmap;
    static MAGIC = DDS_MAGIC;
    static FLAGS = DDS_FLAGS;
    static CAPS = DDS_CAPS;
    static CAPS2 = DDS_CAPS2;
    static PIXEL_FORMAT_FOURCC = DDS_PIXEL_FORMAT_FOURCC;
    static PIXEL_FORMAT_FLAGS = DDS_PIXEL_FORMAT_FLAGS;

    static makeFourCC = makeFourCC;

    static loadHeader(rh: any) {
        let header = new DDSHeader();
        header.magic = rh.readUint32();
        header.size = rh.readUint32();
        header.flags = rh.readUint32();
        header.height = rh.readUint32();
        header.width = rh.readUint32();
        header.pitch = rh.readUint32();
        header.depth = rh.readUint32();
        header.mipmaps = Math.max(1, rh.readUint32());

        rh.skip(4 * 11); // DWORD dwReserved1[11]

        header.pixelFormat.size = rh.readUint32();
        header.pixelFormat.flags = rh.readUint32();
        header.pixelFormat.fourCC = rh.readUint32();
        header.pixelFormat.bitCount = rh.readUint32();
        header.pixelFormat.maskR = rh.readUint32();
        header.pixelFormat.maskG = rh.readUint32();
        header.pixelFormat.maskB = rh.readUint32();
        header.pixelFormat.maskA = rh.readUint32();

        header.caps1 = rh.readUint32();
        header.caps2 = rh.readUint32();
        header.caps3 = rh.readUint32();
        header.caps4 = rh.readUint32();

        rh.skip(4); // DWORD dwReserved2
        return header;
    }

    static getMaskShift(mask: any) {
        let str = mask.toString(2);
        return str.length - (str.lastIndexOf("1") + 1);
    }

    static getMaskScale(mask: any) {
        const str = mask.toString(2);
        const pos = str.lastIndexOf("1");

        if (pos === 0) {
            return 256.0;
        } else {
            return 256.0 / (1 << (pos + 1));
        }
    }

    static load(path: any, callback: any, onError?: (err: any) => void) {
        const texture = new THREE.CompressedTexture();
        texture.image = { width: 0, height: 0 };
        texture.flipY = false;
        texture.generateMipmaps = false;
        texture.unpackAlignment = 1;
        texture.path = path;

        ROSELoader.load(path, function (/** BinaryReader */ rh: any) {
            let maskR: any, maskG: any, maskB: any, maskA: any;
            let shiftR: any, shiftG: any, shiftB: any, shiftA: any;
            let scaleR: any, scaleG: any, scaleB: any, scaleA: any;
            let header, format: any, dxtBlockSize: any;
            let faces, cubemap, readPixelFn: any;
            let mipmaps: any[] = [];

            header = OldDDS.loadHeader(rh);

            if (header.magic !== OldDDS.MAGIC) {
                console.error("DDS.Loader.load: Invalid magic number in DDS header.");
                if (onError) onError(new Error('Invalid DDS magic number in ' + path));
                return null;
            }

            cubemap = !!(header.caps2 & OldDDS.CAPS2.CUBEMAP);
            faces = cubemap ? 6 : 1;

            if (header.pixelFormat.flags & OldDDS.PIXEL_FORMAT_FLAGS.FOURCC) {
                switch (header.pixelFormat.fourCC) {
                    case OldDDS.PIXEL_FORMAT_FOURCC.DXT1:
                        dxtBlockSize = 8;
                        format = THREE.RGB_S3TC_DXT1_Format;
                        break;
                    case OldDDS.PIXEL_FORMAT_FOURCC.DXT3:
                        dxtBlockSize = 16;
                        format = THREE.RGBA_S3TC_DXT3_Format;
                        break;
                    case OldDDS.PIXEL_FORMAT_FOURCC.DXT5:
                        dxtBlockSize = 16;
                        format = THREE.RGBA_S3TC_DXT5_Format;
                        break;
                }
            } else if (header.pixelFormat.flags & OldDDS.PIXEL_FORMAT_FLAGS.RGB) {
                if (header.pixelFormat.flags & OldDDS.PIXEL_FORMAT_FLAGS.ALPHA_PIXELS) {
                    format = THREE.RGBAFormat;
                } else {
                    format = THREE.RGBAFormat;
                    console.debug(
                        "[DDS] RGB-only texture (no alpha) detected, converting to RGBA:",
                        path,
                        "bitCount:",
                        header.pixelFormat.bitCount,
                        "masks:",
                        {
                            R: header.pixelFormat.maskR?.toString(16),
                            G: header.pixelFormat.maskG?.toString(16),
                            B: header.pixelFormat.maskB?.toString(16),
                        }
                    );
                }
            } else if (header.pixelFormat.flags & OldDDS.PIXEL_FORMAT_FLAGS.LUMINANCE) {
                if (header.pixelFormat.flags & OldDDS.PIXEL_FORMAT_FLAGS.ALPHA_PIXELS) {
                    format = THREE.LuminanceAlphaFormat;
                } else {
                    format = THREE.LuminanceFormat;
                }
            } else if (header.pixelFormat.flags & OldDDS.PIXEL_FORMAT_FLAGS.ALPHA) {
                format = THREE.AlphaFormat;
            }

            if (format === undefined) {
                console.warn("Unable to load DDS, unsupported pixel format.");
                console.log(path);
                callback(null);
                return;
            }

            if (!(header.flags & OldDDS.FLAGS.MIPMAP_COUNT)) {
                header.mipmaps = 1;
            }

            rh.seek(header.size + 4);

            if (!(header.pixelFormat.flags & OldDDS.PIXEL_FORMAT_FLAGS.FOURCC)) {
                if (header.pixelFormat.flags & OldDDS.PIXEL_FORMAT_FLAGS.RGB) {
                    maskR = header.pixelFormat.maskR;
                    maskG = header.pixelFormat.maskG;
                    maskB = header.pixelFormat.maskB;
                    shiftR = OldDDS.getMaskShift(maskR);
                    shiftG = OldDDS.getMaskShift(maskG);
                    shiftB = OldDDS.getMaskShift(maskB);
                    scaleR = OldDDS.getMaskScale(maskR);
                    scaleG = OldDDS.getMaskScale(maskG);
                    scaleB = OldDDS.getMaskScale(maskB);
                }

                if (header.pixelFormat.flags & OldDDS.PIXEL_FORMAT_FLAGS.ALPHA_PIXELS) {
                    maskA = header.pixelFormat.maskA;
                    shiftA = OldDDS.getMaskShift(maskA);
                    scaleA = OldDDS.getMaskScale(maskA);
                }

                switch (header.pixelFormat.bitCount) {
                    case 8:
                        readPixelFn = rh.readUint8;
                        break;
                    case 16:
                        readPixelFn = rh.readUint16;
                        break;
                    case 24:
                        readPixelFn = rh.readUint24;
                        break;
                    case 32:
                        readPixelFn = rh.readUint32;
                        break;
                    default:
                        throw "Invalid format, header.pixelFormat.bitCount must be a multiple of 8";
                }
            }

            for (let i = 0; i < faces; ++i) {
                let width = header.width;
                let height = header.height;

                for (let j = 0; j < header.mipmaps; ++j) {
                    const mipmap = new DDSMipmap(width, height);
                    const pixelCount = width * height;
                    let byteCount = pixelCount * (header.pixelFormat.bitCount / 8);

                    switch (format) {
                        case THREE.RGB_S3TC_DXT1_Format:
                        case THREE.RGBA_S3TC_DXT3_Format:
                        case THREE.RGBA_S3TC_DXT5_Format:
                            byteCount =
                                dxtBlockSize *
                                Math.ceil(width / 4) *
                                Math.ceil(height / 4);
                            mipmap.data = rh.readUint8Array(byteCount);
                            mipmap.width = Math.max(4, width);
                            mipmap.height = Math.max(4, height);
                            break;
                        case THREE.RGBAFormat:
                            const hasAlpha = maskA !== undefined;

                            if (!hasAlpha) {
                                console.debug(
                                    "[DDS] RGB-only conversion for:",
                                    path,
                                    "hasAlpha:",
                                    hasAlpha,
                                    "byteCount:",
                                    byteCount,
                                    "pixelCount:",
                                    pixelCount,
                                    "bitCount:",
                                    header.pixelFormat.bitCount
                                );
                                const bytesPerPixel = header.pixelFormat.bitCount / 8;

                                if (
                                    bytesPerPixel === 3 &&
                                    maskR === 0xff &&
                                    maskG === 0xff00 &&
                                    maskB === 0xff0000
                                ) {
                                    console.debug(
                                        "[DDS] Using fast path RGB (standard order, 24-bit)"
                                    );
                                    const rgbData = rh.readUint8Array(byteCount);
                                    mipmap.data = new Uint8Array(pixelCount * 4);
                                    for (
                                        let k = 0, srcIdx = 0, dstIdx = 0;
                                        k < pixelCount;
                                        ++k
                                    ) {
                                        mipmap.data[dstIdx++] = rgbData[srcIdx++];
                                        mipmap.data[dstIdx++] = rgbData[srcIdx++];
                                        mipmap.data[dstIdx++] = rgbData[srcIdx++];
                                        mipmap.data[dstIdx++] = 255;
                                    }
                                } else if (
                                    bytesPerPixel === 3 &&
                                    maskR === 0xff0000 &&
                                    maskG === 0xff00 &&
                                    maskB === 0xff
                                ) {
                                    console.debug(
                                        "[DDS] Using fast path BGR (swapped order, 24-bit)"
                                    );
                                    const rgbData = rh.readUint8Array(byteCount);
                                    mipmap.data = new Uint8Array(pixelCount * 4);
                                    for (
                                        let k = 0, srcIdx = 0, dstIdx = 0;
                                        k < pixelCount;
                                        ++k
                                    ) {
                                        mipmap.data[dstIdx++] = rgbData[srcIdx + 2];
                                        mipmap.data[dstIdx++] = rgbData[srcIdx + 1];
                                        mipmap.data[dstIdx++] = rgbData[srcIdx];
                                        mipmap.data[dstIdx++] = 255;
                                        srcIdx += 3;
                                    }
                                } else {
                                    console.debug("[DDS] Using custom mask path");
                                    mipmap.data = new Uint8Array(pixelCount * 4);
                                    for (let k = 0, idx = 0; k < pixelCount; k++) {
                                        let pixel = readPixelFn.apply(rh);
                                        const r: any = (pixel & maskR) >> shiftR;
                                        const g: any = (pixel & maskG) >> shiftG;
                                        const b: any = (pixel & maskB) >> shiftB;
                                        mipmap.data[idx++] = r * scaleR;
                                        mipmap.data[idx++] = g * scaleG;
                                        mipmap.data[idx++] = b * scaleB;
                                        mipmap.data[idx++] = 255;
                                    }
                                }
                            } else {
                                if (
                                    maskR === 0xff &&
                                    maskG === 0xff00 &&
                                    maskB === 0xff0000 &&
                                    maskA === 0xff000000
                                ) {
                                    mipmap.data = rh.readUint8Array(byteCount);
                                } else if (
                                    maskR === 0xff000000 &&
                                    maskG === 0xff0000 &&
                                    maskB === 0xff00 &&
                                    maskA === 0xff
                                ) {
                                    mipmap.data = rh.readUint8Array(byteCount);

                                    for (let k = 0; k < byteCount; k += 4) {
                                        let r = mipmap.data[k];
                                        mipmap.data[k] = mipmap.data[k + 2];
                                        mipmap.data[k + 2] = r;
                                    }
                                } else {
                                    mipmap.data = new Uint8Array(pixelCount * 4);

                                    for (let k = 0, idx = 0; k < pixelCount; ++k) {
                                        let pixel = readPixelFn.apply(rh);
                                        const r: any = (pixel & maskR) >> shiftR;
                                        const g: any = (pixel & maskG) >> shiftG;
                                        const b: any = (pixel & maskB) >> shiftB;
                                        const a: any = (pixel & maskA) >> shiftA;
                                        mipmap.data[idx++] = r * scaleR;
                                        mipmap.data[idx++] = g * scaleG;
                                        mipmap.data[idx++] = b * scaleB;
                                        mipmap.data[idx++] = a * scaleA;
                                    }
                                }
                            }
                            break;
                        case THREE.LuminanceAlphaFormat:
                            if (maskR === 0xff && maskA === 0xff00) {
                                mipmap.data = rh.readUint8Array(byteCount);
                            } else if (maskR === 0xff00 && maskA === 0xff) {
                                mipmap.data = rh.readUint8Array(byteCount);

                                for (let k = 0; k < byteCount; k += 2) {
                                    const r = mipmap.data[k];
                                    mipmap.data[k] = mipmap.data[k + 1];
                                    mipmap.data[k + 1] = r;
                                }
                            } else {
                                mipmap.data = new Uint8Array(pixelCount * 2);

                                for (let k = 0, idx = 0; k < pixelCount; ++k) {
                                    let pixel = readPixelFn.apply(rh);
                                    const r: any = (pixel & maskR) >> shiftR;
                                    const a: any = (pixel & maskA) >> shiftA;
                                    mipmap.data[idx++] = r * scaleR;
                                    mipmap.data[idx++] = a * scaleA;
                                }
                            }
                            break;
                        case THREE.LuminanceFormat:
                            if (maskR === 0xff) {
                                mipmap.data = rh.readUint8Array(byteCount);
                            } else {
                                mipmap.data = rh.readUint8Array(pixelCount);

                                for (let k = 0; k < pixelCount; ++k) {
                                    let pixel = readPixelFn.apply(rh);
                                    const r: any = (pixel & maskR) >> shiftR;
                                    mipmap.data[k] = r * scaleR;
                                }
                            }
                            break;
                        case THREE.AlphaFormat:
                            if (maskA === 0xff) {
                                mipmap.data = rh.readUint8Array(byteCount);
                            } else {
                                mipmap.data = rh.readUint8Array(pixelCount);

                                for (let k = 0; k < pixelCount; ++k) {
                                    const pixel = readPixelFn.apply(rh);
                                    const a: any = (pixel & maskA) >> shiftA;
                                    mipmap.data[k] = a * scaleA;
                                }
                            }
                            break;
                    }

                    mipmaps.push(mipmap);
                    width = Math.max(1, Math.floor(width / 2));
                    height = Math.max(1, Math.floor(height / 2));
                }
            }

            if (cubemap) {
                let idx = 0;

                for (let i = 0; i < faces; ++i) {
                    const image: any = { mipmaps: [] };

                    for (let j = 0; j < header.mipmaps; ++j) {
                        image.mipmaps.push(mipmaps[idx++]);
                        image.format = format;
                        image.width = header.width;
                        image.height = header.height;
                    }

                    texture.image[i] = image;
                }
            } else {
                texture.image.width = header.width;
                texture.image.height = header.height;
                texture.mipmaps = mipmaps;
            }

            texture.format = format;

            let isDxt =
                format == THREE.RGB_S3TC_DXT1_Format ||
                format == THREE.RGBA_S3TC_DXT3_Format ||
                format == THREE.RGBA_S3TC_DXT5_Format;
            let widthIsPow2 = (header.width & (header.width - 1)) == 0;
            let heightIsPow2 = (header.height & (header.height - 1)) == 0;
            if (isDxt && widthIsPow2 && heightIsPow2 && header.mipmaps > 1) {
                texture.minFilter = THREE.LinearMipMapLinearFilter;
            } else {
                texture.minFilter = THREE.LinearFilter;
            }

            texture.colorSpace = THREE.LinearSRGBColorSpace;

            texture.needsUpdate = true;

            if (callback) {
                callback(texture);
            }
        }, onError);

        return texture;
    }
}
